/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { Select, MenuItem, Grid, InputLabel, FormControl, Tooltip } from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
import { TimestampToDate } from '../../../../../../utils/formatTimestampToDate';
import { useDispatch, useSelector } from 'react-redux';
import { getAllKeyCloakUsers } from '../../../../../../store/reducers/keyCloak/keyCloakAction';
import DeleteKeycloakUser from './DeleteKeycloakUser';

const KeycloakUsers = () => {
    const [loading, setLoading] = useState(false);
    const [realm, setRealm] = useState("getchkd");
    const dispatch = useDispatch();
    const users = useSelector(state => state.keycloak.keyCloakUsers);

    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllKeyCloakUsers({ "realm": realm })).unwrap();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [realm, dispatch]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return (
        <>
            {!loading ? <>
                <Grid container justify="center">
                    <Grid xs={12} sm={6} md={3} style={{ marginBottom: '20px' }}>
                        <FormControl fullWidth  >

                            <InputLabel htmlFor="outlined-Type">Realm</InputLabel>

                            <Select
                                value={realm}
                                variant="outlined"
                                name="realm"
                                label="Realm"
                                style={{ color: 'white' }}
                                onChange={(e) => {
                                    setRealm(e.target.value); fetchUsers();
                                }}
                            >
                                <MenuItem value='getchkd'>
                                    GetChkd
                                </MenuItem>
                            </Select></FormControl>
                    </Grid>
                    <Grid xs={12} sm={12} md={12}>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell label="User Name" />
                                        <StyledTableCell label="Name" />
                                        <StyledTableCell label="E-mail" />
                                        <StyledTableCell label="Enabled" />

                                        <StyledTableCell label="Creation Date" />
                                        <StyledTableCell label="" />

                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {users?.length > 0 && users?.map((row) => (
                                        <React.Fragment key={row.id}>

                                            <StyledTableRow >
                                                <StyledTableCell label={row.username} />
                                                <StyledTableCell label={row.firstName + " " + row.lastName} />
                                                <StyledTableCell label={row.email} />
                                                <StyledTableCell label={row.enabled ? 'true' : 'false'} />

                                                <StyledTableCell label={TimestampToDate(row.createdTimestamp)} />
                                                <StyledTableCell>
                                                    <Tooltip title="Delete User">
                                                            <span>
                                                                <DeleteKeycloakUser username={row.username} />
                                                            </span>
                                                        </Tooltip>

                                                </StyledTableCell>

                                            </StyledTableRow>
                                        </React.Fragment>

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </> : (<Loader />)}

        </>
    )

}

export default KeycloakUsers;
